export default "__VITE_ASSET__B6KaPFXs__"